import React from "react";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import EducationItemForm from "./EducationItemForm";
import { EDUCATION_ITEM_FORM_TEXTS } from "../shared/constants";
import { CommonBoxStyles } from "../shared/styledComponents";

const EducationItemEditPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return (
      <PageLayout showSearch={false}>
        <CommonBoxStyles>
          <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
            {EDUCATION_ITEM_FORM_TEXTS.notFound}
          </Typography>
        </CommonBoxStyles>
      </PageLayout>
    );
  }

  return (
    <PageLayout showSearch={false}>
      <EducationItemForm mode="edit" slug={slug} />
    </PageLayout>
  );
};

export default EducationItemEditPage;
